angular.module("digitalLeasing.module").component("methodOfSendingPeriodicDoc", {
  templateUrl: "ng/components/digitalLeasing/financialAppropriateVerification/methodOfSendingPeriodicDoc/methodOfSendingPeriodicDoc.view.html",
  bindings: {
    model: "=",
    onStructureChanges: "&"
  },
  controllerAs: "sendingPeriodicDocCtrl",
  controller: MethodOfSendingPeriodicDocController
});

function MethodOfSendingPeriodicDocController(
  $typeDomainService,
  $userService
) {
  var self = this;

  self.$onInit = function () {
    self.supportModel = {
      modalities: [],
      modalityDescription: ""
    }

    getSendModality();
  };

  self.handleChange = function (property, value) {
    if (property) {
      self.model.financialCustomer.metadata[property] = value.name;
      self.supportModel.modalityDescription = value.description;

      self.onStructureChanges({
        docStructure: self.model.financialCustomer.metadata.modalitaInvioDocumentazione
      });

      console.log("SendPeriodicDoc: ", self.model);
    }
  }
  var getSendModality = function () {

    $userService.getModalitaInvioDocPer(self.model.financialCustomer)
      .then(function (response) {
        self.supportModel.modalities = response.domainList;
        self.editableDropdown = response.editable;
        if (self.model.financialCustomer.metadata.modalitaInvioDocumentazione != null) {
          self.supportModel.modalities.forEach(function (element) {
            if (self.model.financialCustomer.metadata.modalitaInvioDocumentazione === element.name) {
              self.supportModel.modalityDescription = element.description;
            }
          });
        } else {
          self.model.financialCustomer.metadata.modalitaInvioDocumentazione = self.supportModel.modalities[0].name;
          self.supportModel.modalityDescription = self.supportModel.modalities[0].description;
        }
      })
      .catch(function (error) {
        console.log(error);
      })
  }

}